import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { useContext } from 'react';
import { themed } from '@indeed/ifl-css';
import { d as MenuLink$1 } from '../../reach-menu-button.esm-22bcdd5f.js';
import { StyledMenuItem } from './MenuItem.js';
import { disabledStyles } from '../../utils/styled.js';
import { jsx } from '@emotion/react';
import { LinkProviderContext } from '../LinkProvider/LinkProvider.js';
import '../../reach-popover.esm-c19739dd.js';
import 'react-dom';
import 'focus-visible';

const StyledMenuLink = /*#__PURE__*/themed(StyledMenuItem, process.env.NODE_ENV === "production" ? {
  styleProps: ["disabled"],
  target: "e93f96r0"
} : {
  styleProps: ["disabled"],
  target: "e93f96r0",
  label: "StyledMenuLink"
})(() => ({
  textDecoration: "none",
  display: "block",
  color: "foreground.strong",
  // Hover state
  ':hover, &[data-selected], &[aria-selected="true"]': {
    borderRadius: 0,
    borderColor: "none"
  },
  // Focus state
  ":focus": {
    outline: "none"
  }
}), disabledStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const InnerMenuLink = _ref => {
  let {
    children,
    onSelect = () => {},
    ...props
  } = _ref;
  const {
    onClick: onClickFromContext
  } = useContext(LinkProviderContext);
  return jsx(MenuLink$1, _extends({
    onClick: onClickFromContext,
    onSelect: onSelect
  }, props), children);
};

/**
 * @deprecated The `Menu` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

// We need to make the following casting because of a TS error regarding using a declaration
// (MenuItemImplProps interface) from Reach that cannot be named.
const MenuLink = StyledMenuLink.withComponent(InnerMenuLink, process.env.NODE_ENV === "production" ? {
  target: "e93f96r1"
} : {
  target: "e93f96r1",
  label: "MenuLink"
});
MenuLink.displayName = "MenuLink";

export { MenuLink, StyledMenuLink };
